export default __webpack_public_path__ + "static/media/treat-yourself-1440w.9bd0badc.avif";